import React from 'react';

import { validateForm } from './forms';

export const validateUser = (user, event) => {
  if(user['password']&&user['passwordConfirmation']) {
    if(user['password'].value!==user['passwordConfirmation'].value) return {valid: false, message: 'Passwords do not match'};
  }
  return validateForm(user);
}